import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import _range from 'lodash/range';
import React from 'react';

import { DAY_NAMES } from '../../constants';
import { AvailableHourRange } from '../../models/Sessions';
import { colors } from '../../themes/colors';
import AvailableDayLine from './AvailableDayLine';

type Props = WithStyles<typeof styles> & {
  availableHourRanges?: AvailableHourRange[];
  loading?: boolean;
};

const styles = () =>
  createStyles({
    availabilityList: {
      maxHeight: 200,
      marginTop: 10,
      marginBottom: 10,
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      flexWrap: 'wrap',
      borderRadius: 5,
      padding: 15,
      backgroundColor: colors.gray10,
    },
  });

enum AvailableHoursListTestID {
  Container = 'AvailableHoursListTestID.Container',
}

const AvailableHoursList: React.FC<Props> = ({
  classes,
  availableHourRanges = [],
  loading = false,
}) => {
  const rangesByDay: Record<string, AvailableHourRange[]> = {};

  availableHourRanges.forEach((period) => {
    if (!rangesByDay[period.day]) {
      rangesByDay[period.day] = [];
    }

    rangesByDay[period.day].push(period);
  });

  return (
    <div className={classes.availabilityList} data-testid={AvailableHoursListTestID.Container}>
      {loading && _range(0, 7).map((num) => <AvailableDayLine key={num} loading />)}
      {!loading &&
        Object.keys(DAY_NAMES).map((dayName) =>
          rangesByDay[dayName] ? (
            <AvailableDayLine
              key={dayName}
              dayName={dayName}
              availableHourRanges={rangesByDay[dayName]}
              loading={loading}
            />
          ) : null,
        )}
    </div>
  );
};
export default withStyles(styles)(AvailableHoursList);
